module.exports = __webpack_public_path__ + "static/media/FI.700b05b6.svg";